import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GetInfoAndPassService {

    accessRightSection: Observable<any>;
    private accessRightSectionSubject = new BehaviorSubject<any>("");

    constructor() {
      this.accessRightSection = this.accessRightSectionSubject.asObservable();
    }

    getInfoAndPass(data) {
      this.accessRightSectionSubject.next(data);
    }
}
